import { Pokemon } from "../types/pokemon";

export type AIDifficulty = "easy" | "normal" | "hard";

export function aiPickPokemon(
  cards: Pokemon[],
  currentTeam: Pokemon[],
  difficulty: AIDifficulty
): Pokemon {
  if (cards.length === 0) throw new Error("No cards to pick from");

  switch (difficulty) {
    case "easy":
      return cards[Math.floor(Math.random() * cards.length)];

    case "normal":
      // Pick the Pokemon with highest base stat total
      return cards.reduce((best, p) => {
        const bst = p.stats.reduce((sum, s) => sum + s.value, 0);
        const bestBst = best.stats.reduce((sum, s) => sum + s.value, 0);
        return bst > bestBst ? p : best;
      });

    case "hard":
      return pickWithTypeCoverage(cards, currentTeam);
  }
}

function pickWithTypeCoverage(cards: Pokemon[], team: Pokemon[]): Pokemon {
  const teamTypes = new Set(team.flatMap(p => p.types));

  let bestCard = cards[0];
  let bestScore = -1;

  for (const card of cards) {
    let score = 0;
    for (const type of card.types) {
      if (!teamTypes.has(type)) score += 10;
    }
    score += card.stats.reduce((sum, s) => sum + s.value, 0) / 100;

    if (score > bestScore) {
      bestScore = score;
      bestCard = card;
    }
  }

  return bestCard;
}
